export default __webpack_public_path__ + "static/media/utils_blue.16dee988.svg";